// extracted by mini-css-extract-plugin
export default {"cls1":"RatingCard-cls1__d06799c8775563dc81a9","cls2":"RatingCard-cls2___d61825a36f60e88a0e7 RatingCard-cls1__d06799c8775563dc81a9"};